module.exports = __webpack_public_path__ + "img/img4.50ee1872.png";